import loadable from '@loadable/component'
import {getRouter} from 'hiya-common/src/routes'
import RoomBanner from './RoomBanner'

const routes = getRouter([
  ...RoomBanner,
  {
    path: '/ToyBricksEdit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ToyBricksEdit" */ '~/pages/ToyBricks/edit'
        )
    ),
  },
  {
    path: '/ToyBricksView/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-ToyBricksView" */ '~/pages/ToyBricks/view'
        )
    ),
  },
  {
    // 广播规则页面
    path: '/BroadcastRule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BroadcastRule" */ '~/pages/BroadcastRule'
        )
    ),
  },
  {
    // 年度盘点
    path: '/AnnualSum2022',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualSum2022" */ '~/pages/AnnualSum2022'
        )
    ),
  },
  {
    // 邀请新用户
    path: '/InvitedUser',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-InvitedUser" */ '~/pages/InvitedUser')
    ),
  },
  {
    // 邀请新用户
    path: '/InvitedUser/bind/:code',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-InvitedUser-bindUser" */ '~/pages/InvitedUser/bindUser'
        )
    ),
  },
  {
    // 年度活动2024
    path: '/AnnualActivity2024',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualActivity2024" */ '~/pages/AnnualActivity2024'
        )
    ),
  },
  {
    // 年度活动2024
    path: '/AnnualActivity2024/:rank',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualActivity2024" */ '~/pages/AnnualActivity2024'
        )
    ),
  },
  {
    // 年度活动2024 站外页面
    path: '/AnnualActivity2024OutDownLoad',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualActivity2024-outLink" */ '~/pages/AnnualActivity2024/OutDownLoad'
        )
    ),
  },
  {
    // slot奖励
    path: '/slotReward',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-slotReward" */ '~/pages/SlotReward')
    ),
  },
  {
    // 登宵节
    path: '/israMiraj',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-israMiraj" */ '~/pages/IsraMiraj')
    ),
  },
  {
    // Ramadan2025
    path: '/Ramadan2025',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-Ramadan2025" */ '~/pages/Ramadan2025')
    ),
  },
  {
    path: '/KillAnimal',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-KillAnimal" */ '~/pages/KillAnimal')
    ),
  },
  {
    path: '/KillAnimal2026',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-KillAnimal2026" */ '~/pages/KillAnimal2026')
    ),
  },
  {
    // 年度活动2025
    path: '/AnnualActivity2025',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-AnnualActivity2025" */ '~/pages/AnnualActivity2025'
        )
    ),
  },
  {
    path: '/AnnualActivity2025/:type',
    exact: true,
    component: loadable(
      () =>
        import(/* webpackChunkName: "page-AnnualActivity2025-EndGlory" */ '~/pages/AnnualActivity2025/EndGlory')
    ),
  },
])

export default (store) => routes

// export default (store) =>
//   getRouter([
//     {
//       path: '/KillAnimal',
//       exact: true,
//       component: loadable(
//         () =>
//           import(/* webpackChunkName: "page-KillAnimal" */ '~/pages/KillAnimal')
//       ),
//     },
//   ])
